export function describeImportRequestError(error, subject) {
  const status = error.response?.status;
  if (status === 401) return `${subject}: sesioni ka skaduar. Hyni përsëri në llogari.`;
  if (status === 403) return `${subject}: llogaria nuk ka leje për këtë veprim.`;
  if (status === 404) return `${subject}: shërbimi nuk u gjet. Kontrolloni që backend-i është përditësuar.`;
  if (status === 429) return `${subject}: serveri ka shumë kërkesa. Provoni përsëri pas pak.`;
  if (status >= 500) return `${subject}: gabim në server (HTTP ${status}). Provoni përsëri; nëse vazhdon, kontaktoni administratorin.`;
  if (error.code === "ECONNABORTED" || error.code === "ETIMEDOUT") return `${subject}: serveri nuk u përgjigj brenda kohës së lejuar. Provoni përsëri.`;
  if (!error.response) return `${subject}: nuk u arrit lidhja me serverin. Kontrolloni internetin dhe nëse backend-i është në punë.`;
  if (status === 400 && subject === "Seria e barkodave ACC" &&
      String(error.response.data).includes("limiti maksimal"))
    return "U arrit limiti maksimal i barkodave ACC për kompaninë. Importi nuk mund të gjenerojë barkoda të tjerë.";
  return `${subject}: kërkesa u refuzua nga serveri (HTTP ${status}).`;
}
